import { useMemo } from 'react';

const useStaticImage = (imagePath: string) => {
  const state = useMemo(() => {
    const baseHref = import.meta.env.VITE_BASE_HREF || '/';
    // Clean up image path, remove leading slash and/or leading dot
    const cleanedImagePath = imagePath.replace(/^\.\//, '').replace(/^\//, '');
    const imageUrl = `${baseHref}${cleanedImagePath}`;

    return imageUrl;
  }, [imagePath]);

  return state;
};
export default useStaticImage;
